import { MdxDiv } from '@features/mdx/MdxDiv';
import { AppLanguageCodes } from '@project-types/AppLanguageCodes';
import { MdxPageArticleIds } from '@features/mdx/MdxPageArticleIds';



const articleIds: MdxPageArticleIds = {
	[AppLanguageCodes.CZ]: '29cb6fd1-0fbe-4da0-9e4b-280521b173f4',
	[AppLanguageCodes.SK]: '29cb6fd1-0fbe-4da0-9e4b-280521b173f4',
	[AppLanguageCodes.DE]: '29cb6fd1-0fbe-4da0-9e4b-280521b173f4',
}


export const Advantages = () => {

	return (
		<MdxDiv className='advantages' articleIds={articleIds}>
		</MdxDiv>
	);
};